import { gql, useQuery } from '@apollo/client';

export const GET_COMPANY_BY_ID = gql`
  query getCompanyById($companyId: ObjectId!) {
    getCompanyById(companyId: $companyId) {
      _id
      name
      businessAddress
      email
      logoFileId
      phoneNumber
      timezone
      timezoneFullFormat
      street
      city
      country
      zipCode
      ceo
      mainStreet
      mainHouseNumber
      mainZip
      mainCity
      logoUrl
      ownerMemberId
      subscriptionId
      datevNumberId
      datevNumber {
        _id
        datevNumber
      }
      parentCompanyId
      locations {
        _id
        name
        companyNumber
        datevNumber {
          _id
          datevNumber
        }
        businessAddresses {
          _id
          street
          city
          country
          houseNumber
          zipCode
          holidayLocationId
          holidayLocation {
            name
          }
          departments {
            _id
            name
            costCenter
          }
        }
      }
      departments {
        _id
        name
      }
      parentCompany {
        name
      }
    }
  }
`;

export const useGetCompanyById = (companyId?: string) => {
  const { data, loading } = useQuery(GET_COMPANY_BY_ID, {
    variables: { companyId },
    skip: !companyId,
    fetchPolicy: 'network-only',
  });

  const getCompanyById = data?.getCompanyById || null;

  return {
    company: getCompanyById,
    loading,
  };
};
